import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ProductLogoMediumEquipment as LogoEquipment } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/equipment/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation();
  useDocumentTitle(t('pages.equipment.title'));
  const tabs = [{
    to: '/equipment/overview',
    children: t('common.list.overview'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/equipment',
    children: t('common.list.equipment'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/equipment/items',
    children: t('common.list.items')
  }, {
    to: '/equipment/alerts',
    children: t('common.list.alerts')
  }, {
    to: '/equipment/rule-and-policy/assignment',
    children: t('common.list.ruleAndPolicy')
  }, {
    to: '/equipment/settings',
    children: t('common.list.settings')
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col h-full">
      <ProductHeader Logo={LogoEquipment} name={t('pages.equipment.title')} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}